/**
 * Extend Marb namespace with Web specific content
 *
 * @author Machi
 */

try {
	Marb.extend({
		Page : {
			autosize : function autosize(selector, xtraOpts){
			    var target = $(selector);
			    if( target.data('_autosize') ){
			        return;
			    }
			    var opts = {
			        duration: 90,
			        effect: 'linear',
			        updateWidth: true,
			        updateHeight: true
			    };
			    $.extend(opts, xtraOpts);
			    var div = $('<div></div>');
			    div.hide();
			    div.css('min-width', opts.minWidth || target.width() );
			    div.css('min-height', opts.minHeight || target.height() );
			    if( !opts.updateWidth ){
			    	div.css('width', opts.width || target.width());
			    }
			    if( !opts.updateHeight ){
			    	div.css('height', opts.height || target.height());
			    }
			    div.css('padding', target.css('padding'));
			    div.css('font-family', target.css('font-family'));
			    div.css('font-size', target.css('font-size'));
			    div.css('font-weight', target.css('font-weight'));
			    div.css('border', target.css('border'));
			    div.css('word-wrap', target.css('word-wrap'));
			    if( opts.extraClass ){
			        div.addClass(opts.extraClass);
			    }
			    //etc

			    target.parent().append(div);
			    target.css('overflow', 'hidden');
			    target.keyup(function(){
			        div.text($(this).val());
			        var size = {};
			        if( opts.updateHeight ){
			        	size.height = div.height()+'px';
			        }
			        if( opts.updateWidth ){
			        	size.width = div.width() + 'px';
			        }
			        target.animate(
			        		size,
			        		opts.duration,
			                opts.effect);
			    });

			    target.data('_autosize', 1);

			},
			/**
			 * Receives in 'data':
			 * data.textId id of the input
			 * 		showing results (text)
			 * data.valueId the hidden input containing the ID
			 * 		of the item selected
			 * data.containerId: the container of the suggested elements
			 */
			setAutocomplete : function(url, data, onSelect, dataTable) {
				var textId = '#' + data.textId;
				var valueId = '#' + data.valueId;
				var filter = data.filter || null;
				var trackResult = data.trackResult == false ? false : true;
				var isWarranty = data.isWarranty;
				var jobId = data.jobId;
				if( data.textWatermark){
					$(textId).watermark(data.textWatermark);
				}

				$(textId).on({
					click: function(){
						if( ! $(textId).attr('srch-clickd') ){
							$(textId).attr('srch-clickd','true');
							$(textId).val('');
						}
						$(textId).removeClass('error');
					},
					blur: function(){
						if( $(textId).data('lastuniquevalue') ){
							$(textId).val($(textId).data('lastuniquevalue'));
							$(valueId).val($(valueId).data('lastuniquevalue'));
						}else if( $(valueId).val() ){
							$(textId).val( $(textId).data('lastvalue') );
						}else{
						    $(textId).val("");
						}
					}
				});
				var container = $("<div class='ui-autocomplete-container' style='position: absolute; z-index: 9999;' ></div>");
				container.width($(textId).width());
				container.appendTo("body");
				$(textId).autocomplete({
					minLength: 3,
					delay: 300,
					appendTo: container,
					close: function(event, ui){
						$(valueId).change();
					},
					select: function(event, ui){
						$(valueId).val(ui.item.id);
						if(onSelect){
							dataTable.fnClearTable(0);
							dataTable.fnDraw();
						}
						
					},
					source: function(request, response){
						var loading = $("<div class='input-loading'>&nbsp;</div>");
						loading.appendTo("body");
						loading.position({
							my: 'right',
							at: 'right-10',
							of: $(textId)
						});
						var params = {term: request.term, filter: filter, jobId: jobId};
						if(isWarranty){
							params = {term: request.term, filter: filter, isWarranty: isWarranty, jobId: jobId};
						}
						$.extend(params, data);
						$.getJSON(url,params,function(queryResponse){
							if(trackResult && request.term && request.term.length > 3){
								Marb.Commons.Track.event('location-search', request.term, 'home');
							}
							loading.remove();
							$(textId).data('lastuniquevalue','');
							$(valueId).data('lastuniquevalue','');
							if( queryResponse.success ){
								var parentUl = $("<ul class='ui-autocomplete ui-front ui-menu ui-widget ui-widget-content ui-corner-all'></ul>");
								var parentLi = $('<li class="ui-menu-item">');
								parentUl.append(parentLi);
								var lengthDiv = $('<a class="ui-corner-all" tabindex="-1"></a>');
								parentLi.append(lengthDiv);

								var longestText = "";
								var resultSize = queryResponse.data.length;
								for(var i=0; i < resultSize; i++){
									var txt = queryResponse.data[i].label;
									if( txt.length > longestText.length ){
										longestText = txt;
									}
								}
								if( resultSize == 1 ){
									$(textId).data('lastuniquevalue',queryResponse.data[0].label);
									$(valueId).data('lastuniquevalue',queryResponse.data[0].id);
								}
								lengthDiv.text(longestText);
								parentUl.appendTo('body');
								var width = lengthDiv.width();
								parentUl.remove();
								if( $(window).width() > 640 ){
									container.width(width*1.25);
								}

								response(queryResponse.data)
							}else{
								response();
							}
						});
					},
					focus: function(event, ui){
						$(textId).val(ui.item.label);
						$(valueId).val(ui.item.id);
						$(textId).data('lastvalue', ui.item.label);
					}
				});
			},

			drawStars : function(data) {
				var value = data.value;
				var parent = data.selector;
				var cont = $('<div class="star-rating"></div>');
				for(var i=0; i < 5; i++){
					if(value == 0) {
						cont.append('<div class="starEmpty"></div>');
					}
					else if( i <= value){
						cont.append('<div class="starOn"></div>');
					}
					else {
						cont.append('<div class="starOff"></div>');
					}
				}
				if( parent ) {
					parent.append(cont);
				}

				return cont;
			},

			scrollables : function(selector){
				selector = selector || '.scrollable';
				$(selector).mCustomScrollbar({
					theme: 'dark-thick',
					scrollInertia: 0
				});
			},

			scrollable : function (selector, action){
				if( action  == 'update'){
					$(selector).mCustomScrollbar('update');
					$(selector).mCustomScrollbar('scrollTo','last');
				}else if( action == 'init'){
					Marb.Page.scrollables(selector);
				}
			},

			Toast : {
				defaultToast : '<div style="display:none;width:100%;position:fixed;top: 0px;z-index: 2000;" class="wrapper"><div class="content alert title-m" style="text-align:center;max-width:400px;margin: 0 auto;border-top-left-radius: 0px;border-top-right-radius: 0px;border-color: #6AA52F;border-top: 0px;line-height: 60px;"></div></div>',
				/**
				 * Shows a message for a brief period of time and then
				 * disappears
				 * Params:
				 * - data.text: the text to be displayed
				 * - data.time: a number of seconds to display or one of the following
				 * 	 fixed values ('short','medium','long')
				 * - data.complete: callback Function to execute onSuccess, after the message disappeared.
				 */
				success : function(data){
					var time = data.time || 2500;
					var text = data.text || 'info';
					var style = data.style || 'alert-success';
					var callback = data.complete;
					var toast = $(this.defaultToast);
					$('.content',toast).html(text);
					$('.content',toast).addClass(style);

					$(toast).appendTo($('body')).show(
						'slide',{direction: 'up'},
						function(){
							$(this).delay(time).hide('slide',{direction: 'up'}, callback);
						}
					);
				},

				warn : function(data){
					data = data || {};
					data.style = 'alert-warning';
					M.Page.Toast.success(data);
				},
				error: function(data){
					data = data || {};
					data.style = 'alert-error';
					M.Page.Toast.success(data);
				}

			},

			MobileLayout : (function() {
				var _params;
				var initialize = function(params) {
					_params = params;
					if(_params.userType == '' || _params.userType.toUpperCase() == 'CUSTOMER') {
						manageAndroidAppAd();
					}

					bindEvents();
				};

				var manageAndroidAppAd = function() {

					var iPhone = navigator.platform.indexOf("iPhone") > 0;
					var iPad = navigator.platform.indexOf("iPad") > 0 ;
					var iPod = navigator.platform.indexOf("iPod") > 0;
					var android = navigator.userAgent.indexOf('Android') > 0;
					var cookieNoBanner = getCookie('androidCookie');		
	
					if (!android || cookieNoBanner ){
						return;
					}

					var cookieName = 'ifix-android-app';
					var androidAppCookie = $.cookie(cookieName);
					var d = new Date();
					var c = {
						times : 0,
						expires : d.setDate(d.getDate() + 7) //expires in a week
					};

					if(androidAppCookie !== undefined) {
						c = JSON.parse(androidAppCookie);
					}

					switch(c.times) {
						case 0:
						case 1:
							$('body').addClass('android-banner');
							$('#android-app-bar').show();
							$('#android-app-bar').on('click', function(){
								window.location.href = 'https://play.google.com/store/apps/details?id=com.marb.iguana';
							});
							$('#android-app-bar .close').on('click', function(){
								$('body').removeClass('android-banner');
								$('#android-app-bar').hide();
								c.times = 2;
								$.cookie(cookieName, JSON.stringify(c), {
									expires : new Date(c.expires),
									path: '/'
								});
								return false;
							});
							break;
						default:
							break;
					}
					if( c.times == 0 ){
						c.times = 1;
					}
					$.cookie(cookieName, JSON.stringify(c), {
						expires : new Date(c.expires),
						path: '/'
					});

				};

				var bindEvents = function() {
					$('#android-app-bar .close-btn').on('click', eventHandlers.onCloseAndroidBar);
				};

				var eventHandlers = {
					onCloseAndroidBar : function() {
						$('#fixedBannerHolder').hide();
						$(window).trigger('resize');
					}
				};

				return {
					initialize : initialize
				};
			})(),

			customSelect: function(selector){
				$(selector).each(function(){
		            var title = $(this).data('dflt');
		            if( ! title ){
		            	title = $(this)[0][$(this)[0].selectedIndex].text;
		            }else{
		            	$(this).parent().addClass('dd-dflt');
		            }
		            var span = $('<span class="select">' + title + '</span>');
		            $(this)
		                .css({'opacity':0,'-khtml-appearance':'none'})
		                .after(span)
		                .change(function(){
		                    val = $('option:selected',this).text();
		                    $(this).next().text(val);
		                });
		            var ddImg = $('<div class="dd-img"></div>');
		            $(this).parent().append(ddImg);
		            var dataWidth = $(this).width();
		            var dataSet = $('<ul></ul>');
		            dataSet.width(dataWidth);
		            var select = $(this)[0];
		            $(this).children('option').each(function(pos){
		            	var option = $('<li></li>');
		            	option.text($(this).text());
		            	option.on('click',function(){
		            		select.selectedIndex = pos;
		            		$(select).change();
		            		$(select).parent().removeClass('dd-dflt');
		            	});
		            	dataSet.append(option);
		            });
		            dataSet.hide();
		            $(this).parent().append(dataSet);
		            span.on('click', function(){
		            	dataSet.toggle();
		            	return false;
		            });
		            ddImg.on('click', function(){
		            	dataSet.toggle();
		            	return false;
		            });
		            $('body').on('click', function(){
		            	dataSet.hide();
		            });
		        });
			},

			richText: function(params){

				tinymce.init({
					plugins: 'paste',
					paste_auto_cleanup_on_paste : true,
					paste_remove_styles: true,
					paste_strip_class_attributes: "all",
					/*
					paste_remove_styles_if_webkit: true,
					paste_text_sticky_default: true,
					paste_text_sticky: true,
					*/
					valid_elements: "br,h1[style],h2[style],h3[style],p[style],span[style],div[style],ul[style],li[style],strong,b,ol[style],italic",
					paste_as_text: false,
					theme : "modern",
					selector : params.selector,
					menubar : false,
					height : params.height || 300,
					toolbar : 'undo redo | bold italic | strikethrough | alignleft aligncenter alignright alignjustify  | h1 h2 h3 | bullist numlist outdent indent',
					setup : function(ed) {

						// Register example button
						ed.addButton('h1', {
							icon : 'h1',
							onclick : function() {
								ed.execCommand('FormatBlock', false, 'h1');
							}
						});
						ed.addButton('h2', {
							icon : 'h2',
							onclick : function() {
								ed.execCommand('FormatBlock', false, 'h2');
							}
						});
						ed.addButton('h3', {
							icon : 'h3',
							onclick : function() {
								ed.execCommand('FormatBlock', false, 'h3');
							}
						});
					}
				});
			},

			/**
			 * Initializes all "standard" dropdowns in a page
			 * that is dropdowns need to contain the '.dropdown'
			 * selector
			 */
			dropdowns : function(){
				$('.dropdown').each(function(){
					Marb.Page.dropdown($(this));
				});
			},

			customDropdown: function(clickable, menu) {

				if( clickable.data('dropdown-inited') ){
					return;
				}
				menu.addClass('dropdown-data');
				menu.children('li').addClass('dropdown-item');
				menu.on({
					mouseover: function(){
						if( $(this).hasClass('disabled') ){
							return;
						}
						menu.show();
					},
					mouseleave: function(){
						menu.hide();
					}
				});
				clickable.on({
					mouseover: function(){
						if( $(this).hasClass('disabled') ){
							return;
						}
						menu.show();
					},
					mouseleave: function(){
						menu.hide();
					}
				});
				clickable.data('dropdown-inited', true);
			},
			dropdown : function(obj){
				var dd = $(obj);
				if( dd.data('dropdown-inited') ){
					return;
				}
				var menu = dd.children('ul');
				menu.addClass('dropdown-data');
				menu.children('li').addClass('dropdown-item');
				menu.on({
					mouseover: function(){
						if( $(this).hasClass('disabled') ){
							return;
						}
						menu.show();
					},
					mouseleave: function(){
						menu.hide();
					}
				});
				dd.children('div').on({
					mouseover: function(){
						if( $(this).hasClass('disabled') ){
							return;
						}
						menu.show();
					},
					mouseleave: function(){
						menu.hide();
					}
				});
				dd.data('dropdown-inited', true);
			},

			/**
			 * params:
			 * 		- validation (function that returns true or false before saving)
			 * 		- onBeforeEdit (action to perform before editing)
			 * 		- onPostSave (action to perform after saving)
			 * 		- onPostCancel (action to perform after saving)
			 * 		- onSave (has default behavior)
			 * 		- onCancel (has default behavior
			 */
			editable : function(selector,params) {
				var params = params || {};
				$(selector).each(function(){
					var parentDiv = $(this);
					var editModeClass = "edit-mode";
					var viewModeClass = "view-mode";
					setViewMode(parentDiv);
					$('.editable:input', $(this)).each(function(){

						$(this).hide();

						var val = $(this).val();

						if(this.tagName == "SELECT") {
							$(this).data("options",$("option",this).clone());
							val = $("option:selected",$(this)).get(0).text;
						}
                        var currentVal = $(this).data("currentval");

                        val = currentVal ? currentVal : val;

						var readonlyText = $("<span>" + val + "</span>");
						$(this).data("origval", val);
						readonlyText.addClass("readable");
						readonlyText.addClass("font-c3");
						$(this).after(readonlyText);

					});
				
					var save = $("<span class='btn btn-info'>"+$.i18n.prop('p.generic.save')+"</span>");
					var cancel = $("<span class='btn btn-info'>"+$.i18n.prop('p.generic.cancel')+"</span>");
					var buttonDiv = $("<div class='button-container'></div>")
					buttonDiv.append(save);
					buttonDiv.append(cancel);
					buttonDiv.hide();
					parentDiv.append(buttonDiv);

					var editTxt = $.i18n.prop('p.generic.edit');
					var edit = $("<div class='edit-btn btn btn-orange btn-warning edit-container'><img src='/static/images/edit-pen-white.png'>&nbsp;"+editTxt+"</div>");
					$(parentDiv).prepend(edit);

					$(cancel).click(params.onCancel || function(){
						$('.button-container',parentDiv).hide();
						$('.edit-btn').show();
						$(".readable", parentDiv).show();
						$(".editable:input", parentDiv).hide();
						setViewMode(parentDiv);
						if(params.onPostCancel) params.onPostCancel();
					});

					var validation = params.validation || function(){ return true;}

					$(save).click(params.onSave || function(){
						if(!validation()) return;
						parentDiv.css("opacity",0.2);
						var form = $(this).closest("form").clone();
						var editableUrl = parentDiv.data("editableurl");
						if(editableUrl) {
							form.attr("action",editableUrl);
						}
						//form.submit();
						$.post(form.attr("action"), $(form).serialize(), function(data){
							if(data.success) {
								$('.button-container',parentDiv).hide();
								$('.edit-btn', parentDiv).show();
								$(".readable", parentDiv).show();

								$(".editable:input", parentDiv).each(function(){
									$(this).hide();
									var readable = $(this).next(".readable");
									readable.show();

									var val = $(this).val();
									if(this.tagName == "SELECT") {
										$(this).data("options",$("option",this).clone());
										val = $("option:selected",$(this)).get(0).text;
									}
									if( $(this).hasClass('editable-html') ){
										readable.html(val);
									}else{
										readable.text(val);
									}
									$(this).data("origval", val);
									Marb.Page.Toast.success({'text': $.i18n.prop('p.toast.modification.success')});

								});
								if(params.onPostSave) params.onPostSave();
							} else {
								var errorCode = data.errorCode ? data.errorCode : (data.message ? data.message : 'p.toast.modification.error');
								Marb.Page.Toast.error({'text': $.i18n.prop(errorCode)});
								cancel.click();
							}
							parentDiv.css("opacity",1);
							setViewMode(parentDiv);
						})
					});

					$(".edit-container",this).click(function(){
						$(this).hide();
						$('.button-container',parentDiv).show();
						$('.editable:input', parentDiv).each(function(){
							$(this).val($(this).data("origval"));
							$(this).show();
							$(".readable", parentDiv).hide();
							if(this.tagName == "SELECT") {
								var options = $(this).data("options");
								$("option",this).remove();
								$(this).append(options.clone());
							}
						});
						setEditMode(parentDiv);
						if(params.onBeforeEdit){
							params.onBeforeEdit();
						}
					});
					function setViewMode(el) {
						$(el).addClass(viewModeClass);
						$(el).removeClass(editModeClass);
                        $('input[type="checkbox"]#subscribedToOffers').prop('disabled', true);
                    }

					function setEditMode(el) {
						$(el).removeClass(viewModeClass);
						$(el).addClass(editModeClass);
                        $('input[type="checkbox"]#subscribedToOffers').removeAttr('disabled');
					}
				});
			},
			/**
			 * Show tooltips next to input elements
			 * Param:
			 * 	data: {
			 * 		formId: the id of the form containing the inputs,
			 * 		selector: a standard selector, if formId is not specified
			 *  }
			 */
			tooltips : function(data) {
				var formId = data.formId ? '#' + data.formId : ( data.selector || 'form' );
				var tooltipTemplateId = data.tooltipId ? '#' + data.tooltipId : null;
				var orientation = data.orientation || 'right';
				var onBeforeShow = data.onBeforeShow || function(){return true};

				$(formId).find('input, textarea, select, .tooltip.help-icon').each(function(idx){
					var dataHelp = $(this).data('help');
					var dataTitle = $(this).attr('title');
					var helpText =  dataHelp ? dataHelp : dataTitle? dataTitle : null;
					var htmlName = $(this).attr('name') || $(this).data('name');
					if( htmlName && helpText ){
						var showFunction = function(){
							if( $('#help-'+htmlName)[0] || ! onBeforeShow($(this)) ){
								return;
							}
							var tooltip = null;
							if( tooltipTemplateId ){
								tooltip = $( tooltipTemplateId).clone();
							}else if( data.tooltipHtml){
								tooltip = $(data.tooltipHtml);
							}else{
								tooltip = $('<div class="help" id="help-tooltip-template">'+
										    '	<div class="arrow"></div>'+
										    '	<div class="help-text"></div>'+
										    '</div>');
								if( data.tooltipClass ){
									tooltip.addClass(data.tooltipClass);
								}
							}
							tooltip.attr('id', 'help-' + htmlName);
							tooltip.addClass('o-'+orientation);
							//might have chaged for dynamic help boxes
							dataHelp = $(this).data('help');
							dataTitle = $(this).attr('title');
							helpText =  dataHelp ? dataHelp : dataTitle? dataTitle : null;
							tooltip.find('.help-text').html(helpText);
							$(this).parent().append(tooltip);
							tooltip.css('z-index',1000);
							tooltip.show();
							if( orientation == 'right'){
								tooltip.position({
									my: 'left top',
									at: 'right+13 top-10',
									of: $(this),
									collision: 'fit fit'
								});
							}else if(orientation == 'top'){
								tooltip.position({
									my: 'center bottom',
									at: 'top-10',
									of: $(this),
									collision: 'fit fit'
								});
							}
						};

						var hideFunction = function(){
							var tooltip = $('#help-' + htmlName);
							if( tooltip ){
								tooltip.hide();
								tooltip.remove();
							}
						};

						if( $(this).hasClass('help-icon') ){
							$(this).on({
								mouseenter: showFunction,
								mouseleave: hideFunction
							});
						}else{
							$(this).on({
								focus: showFunction,
								blur: hideFunction
							});
						}
					}
				});
			}
		},
		Customer :{
			loadTaxIdTypes: function(targetSelector, params, callback){
				var country = params.country || "";
				$.getJSON('/util/taxIdTypes',{c: country}, function(data){
					var mainOption ='<option value="">' + $.i18n.prop('p.generic.chooseOne') + '</option>';
					var html = mainOption;

					$.each(data, function(key, val) {
						html += '<option value="' + key + '">' + val + '</option>';
					});
					$(targetSelector).html(html);
					if( params.onChange ){
						params.onChange(data);
					}
					if(callback){
                    	callback();
					}
				});
			}
		},
		Category : {
			/**
			 * params = {onChange=function...}
			 */
			loadCombo : function(categoryId, subcategoryId, params){
				var categorySel = '#' + categoryId;
				var subcatSel = '#' + subcategoryId;

				$(categorySel).change(function(){
					var val = $(this).val();
					$.getJSON('/categories/'+val+'/list',function(response){
						if( response.success ){
							var html = "";
							$.each(response.data.categories, function(idx){
								html += '<option value="' + this.id + '">' + this.name + '</option>';
							});
							$(subcatSel).html(html);
						}else{
							alert('no such category');
						}
					});
				});
			},

			setCategoryAutocomplete : function(data){
				M.Page.setAutocomplete('/categories/search', data);
			}
		},
		Product : {
			/** 
			 * Used to search products
			 */			
			setProductAutocomplete : function(url, data) {
				var textId = '#' +data.textId;
				var containerId = '#' +data.containerId;
				var filter = data.filter;
				var trackResult = data.trackResult == false ? false : true;
				if( data.textWatermark){
					$(textId).watermark(data.textWatermark);
				}
				var delay = (function(){
					  var timer = 0;
					  return function(callback, ms){
					    clearTimeout (timer);
					    timer = setTimeout(callback, ms);
					  };
					})();
				$(textId).keyup(function(){ 
						 delay(function(){
							 var term = $(textId).val();
							 var lastTerm = $(containerId).data('lastterm');
							 if( term == lastTerm ){
								 return;
							 }
							 $(containerId).data('lastterm', term);
							 var loading = $("<div class='input-loading-pi'>&nbsp;</div>");
								loading.appendTo("body");
								loading.position({
									my: 'right',
									at: 'right-10',
									of: $(textId)
								});
							 $(paddingBottomSearch).hide();
							 if( term && term.length > 3){
									$.getJSON(url,{term: term, filter: filter},function(queryResponse){
										if(trackResult){
											Marb.Commons.Track.event('product-search', term, 'home');
										}
										loading.remove();
										$(containerId).html("");
										var i = 0;
										var piRow;
										var piResult;
										$.each(queryResponse.data, function(){	
											
											if(i==0){
												piResult = "";
											}
											piRow ="";											
											piRow += '<div class="product col span_6_12 i'+i%2+'">'+ 
													 '<a href="'+this.link+'">'	+
													 '<span class="label">'+this.label+'</span>'+
													 '<span class="price-from">'+this.price+'</span>'+
													 '<span class="hire-service-arrow">&gt;</span>'+
													 '</a> </div>';
											
											piResult += piRow;
											i++;											
										});
										if( i == 0 ){
											var noResults = $('#product-no-results-template');
											if( noResults.length > 0){
												noResults = noResults.clone();
												noResults.attr('id', '');
												noResults.removeClass('collapse');
												piResult = $('<div></div>').append(noResults).html();
											}
										}
										$(containerId).append(piResult);
										$(containerId).slideDown('fast');
										$(paddingBottomSearch).slideDown('fast');
										 
									});	
							 } else if(term==null || term.length <= 3){
								 $(containerId).slideUp('fast');
								 $(paddingBottomSearch).slideUp('fast');
								 loading.remove();								
							 }
						},	 300);					 	
				});
			},			
		},
		Validate : {
			/**
			 * Initializes validation of a form of fields created using inputText.tag
			 * params = {
			 * 		formId: the id of the form to validate,
			 * 		options: {} additional parameters you may want to set or override as in 'validation.js'
			 * }
			 */
			init : function(data) {
				var options = data.options || {};
				var hasCustomValidation = 	data.options && 
											data.options.customRules && 
											data.options.customMessages;
				var vdata = {
						rules: {
							"username": {
		        				required: true,
		        				email: true,
		        				remote: {
		    						url: "/email-check",
		    						type: "get",
		    						data: {
							          username: function() {
							            return $("#reg_username").val();
							          }
							        }
		    					}
		        			}		        			
						},
						messages: {},
						errorPlacement: function(error, element){
							error.addClass("custom-error");
							if(element.is(":checkbox")){
								error.insertBefore(element);
							}else{
								error.insertAfter(element);
							}
						},
						errorElement: "div"
					};
				if( ! data.ignore ){
					$.validator.setDefaults({
						ignore: []
					});
				}else{
					vdata.ignore = data.ignore;
				}
				var form = '#' + data.formId;
				$(form).find(":text, :password, :hidden :input, :checkbox, textarea, select").each(function(idx){
					var obj = $(this);
					var name = obj.attr('name');
					var keyName = name;
					if(name){
						name = name.replace('.','\\.');
					}
					var validate = false;

					vdata.rules[keyName] = {};
					vdata.messages[keyName] = {};
					var rules = vdata.rules[keyName];
					var msgs = vdata.messages[keyName];
					var classes = obj.attr('class') || "";
					
					var errorMsg = $('#label-for-'+name).data('errormsg');
					if( !errorMsg ){
						//try the current objects data-errormsg
						errorMsg = obj.data('errormsg');
					}
					

					if( obj.hasClass('v-req') ){
						rules['required'] = true;
						msgs['required'] = errorMsg;
					}
					if( obj.hasClass('v-email') ){
						rules['email'] = true;
						msgs['email'] = errorMsg;
					}
					if( obj.hasClass('v-date')){
						rules['v-date'] = true;
						msgs['v-date'] = errorMsg;
					}
					if( obj.hasClass('v-dateISO') ){
						rules['v-dateISO'] = true;
						msgs['v-dateISO'] = errorMsg;
					}
					if( obj.hasClass('v-number') ){
						rules['number'] = true;
						msgs['number'] = errorMsg;
					}
					if( obj.hasClass('v-digits') ){
						rules['digits'] = true;
						msgs['digits'] = errorMsg;
					}
					if( obj.hasClass('v-creditcard') ){
						rules['creditcard'] = true;
						msgs['creditcard'] = errorMsg;
					}
					if( new RegExp("\\bv-equalTo_").test(classes) ){
						var other = classes.match(/v-equalTo_(\S+)/)[1];
						var otherObj = $('#value-for-'+other);
						if( ! otherObj[0] ){
							otherObj = $('#' + other);
						}
						rules['equalTo'] = otherObj;
						msgs['equalTo'] = errorMsg;
					}
					if( new RegExp("\\bv-maxLength_").test(classes) ){
						var other = classes.match(/v-maxLength_(\S+)/)[1];
						rules['maxlength'] = other;
						msgs['maxlength'] = errorMsg;
						if( ! msgs['maxlength'] ){
							msgs['maxlength'] = obj.data('errormsg');
						}
					}
					if( new RegExp("\\bv-minLength_").test(classes) ){
						var other = classes.match(/v-minLength_(\S+)/)[1];
						rules['minlength'] = other;
						msgs['minlength'] = errorMsg;
					}
					if( new RegExp("\\bv-max_").test(classes) ){
						var other = classes.match(/v-max_(\S+)/)[1];
						rules['max'] = other;
						msgs['max'] = errorMsg;
					}
					if( new RegExp("\\bv-min_").test(classes) ){
						var other = classes.match(/v-min_(\S+)/)[1];
						rules['min'] = other;
						msgs['min'] = errorMsg;
					}
				});
				
				if (hasCustomValidation){
					$.each(options.customRules, function(key, value){
						vdata.rules[key] = value;
					});
					$.each(options.customMessages, function(key, value){
						vdata.messages[key] = value;
					});
				}
				$.extend(true,vdata, options);
				$(form).validate(vdata);

			},

			/**
			 * Validates if the form with the given id is valid
			 * and returns true if so.
			 */
			valid : function(formId){
				return $('#'+formId).validate().form();
			},
			
			validateDefaultPrices : function (){
				 var proPriceInput = $('#value-for-pricing\\.variableProPrice');
				    var marketplacePriceInput = $('#value-for-pricing\\.variableMarketplacePrice');
				    var resellerPrice = $('#value-for-pricing\\.variableResellerPrice');	    
				    var proPriceGreaterThanMkt = eval(proPriceInput.val())>eval(marketplacePriceInput.val());
				    var mktPriceGreaterThanReseller = eval(marketplacePriceInput.val())>eval(resellerPrice.val());
				    if(proPriceGreaterThanMkt || mktPriceGreaterThanReseller){	
				    	var errorMsg="";
				    	if(proPriceGreaterThanMkt){		    
					    	errorMsg+= "&#8680;Default Pro Price must be less than or equal to Default Iguanafix sale Price. "
				    	}
				    	if(mktPriceGreaterThanReseller){  
					    	if(errorMsg){
					    		errorMsg+= "<br/>";
					    	}
					    	errorMsg+= "&#8680;Default Iguanafix sale Price must be less than or equal to Default Reseller Price. "
				    	}
				    	$('#errorValidating').html(errorMsg);
				    	$("html, body").animate({ scrollTop: 100 }, "slow");
				    	$('#errorValidating').show();
				    	return false;
				    }
				    return true;
			}
		},
		Commons : {
			Utils : {

				/**
				 * On window change size check if the currently
				 * selected input element is focused and visible.
				 */
				performSoftKeyboardDetection: function(){
					//potential leak here, as we are never removing
					//these handlers. though if used only in popups
					//they should be automatically destroyed
					var elem = document.activeElement;
					var type = elem && elem.tagName.toLowerCase() || null;
					elem = $(elem);
					if( type && ( type == 'textarea' || type == 'input' ) ){

						var win = $(window);
						var objMaxPos = elem.offset().top + elem.height();
						var screenHeight = win.scrollTop() + win.height();
						console.log(objMaxPos + ' / ' + screenHeight);
						if( objMaxPos > screenHeight ){
							$('body').addClass('softKBOn');
							elem.addClass('softKBOn');
							var ff = function(){
								elem.removeClass('softKBOn');
								$('body').removeClass('softKBOn');
							};
							elem.blur(ff);
						}else{
							elem.removeClass('softKBOn');
							$('body').removeClass('softKBOn');
						}
					}
				},
				/**
				 * Utility method that checks if the
				 * KB detection is already running and if not
				 * it starts it.
				 */
				enableSoftKeyboardDetection: function(){
					if( $(window).width() < 460 ){
						M.Commons.Utils.disableSoftKeyboardDetection();
						$(window).resize( Marb.Commons.Utils.performSoftKeyboardDetection );
					}
				},
				disableSoftKeyboardDetection: function(){
					$(window).off('resize', Marb.Commons.Utils.performSoftKeyboardDetection);
					$('input.softKBOn, textarea.softKBOn').each(function(){
						$(this).removeClass('softKBOn');
						$('body').removeClass('softKBOn');
					});
				},
				/**
				 * Shows a popup.
				 * if 'data' is a string, it is assumed to be a selector
				 * Param:
				 * data (Object) :{
				 *   id: the container ID of the popup. Only the title will be used and the contents of the body replaced with the remote response
				 *   url: a remote URL that returns HTML to be inserted inside
				 *   the 'body' of the model
				 * }
				 * ;
				 * data (string): the ID of the container pop-up. The HTML Element
				 * should have an h1 as the title and a div as the body as only
				 * elements. Everything else is removed.
				 */
				popup : function(data, params) {
					if( typeof data === 'string' || data.id && !data.url){
						var id = data.id || data;
						var popup = $("#" + id);
						if( ! popup.data('simplemodalinited')){
							var title = popup.children(':first').detach();
							var content = popup.children('div:last').detach();
							popup.data('simplemodalinited', true);

							popup.html('');
							var titleDom = $('<div class="simplemodal-title"></div>');
							popup.append(titleDom);
							var closeBtn = $('<div class="simplemodal-close">&times;</div>');
							closeBtn.click(function(){
								$.modal.close();
							});
							titleDom.append(title);
							titleDom.append(closeBtn);
							var contentDom = $('<div class="simplemodal-body"></div>');
							popup.append( contentDom);
							contentDom.append(content);
							M.Commons.Utils.enableSoftKeyboardDetection();
						}
						popup.modal({
							focus: false,
							onClose: function(){
								M.Commons.Utils.disableSoftKeyboardDetection();
								$.modal.close();
							}
						});
						M.Commons.Utils.popupResize(popup, params);
					}else{
						if (!data.id){
							$.get(data.url, function(data){

								var el = $('<div class="collapse"></div>');
								var popupid = 'modal-unique-id';
								$("#" + popupid).remove();
								el.attr('id', popupid);
								el.html($.parseHTML(data,true));
								el.appendTo('body');
								
								Marb.Commons.Utils.popup(popupid);
							});
							return;
						}

						var popup = $(data.id);
						var title = popup.children('h1').html();
						var content = $(popup.children('div')[0]);

						popup = $('<div class="collapse"></div>');
						popup.append('<div class="simplemodal-title font-c1 title-s">' +title+'</div>');
						var container = $('<div class="simplemodal-body"></div>');
						container.addClass('simplemodal-remote');
						container.append(content);
						popup.append( container);

						var url = data.url;
						if( ! url ){
							debug.error('Error with url in Marb.Commons.Utils.popup',{url : url});
						}
						popup.modal({focus: false});

						container.load(url, function(responseText, textStatus, XMLHttpRequest){
							if(textStatus != 'error') {
								var i = 10;
								var pp = popup;
								M.Commons.Utils.popupResize(pp, params);
							}
							else {
								debug.error('Could not fetch remote popup content from given url',{url : url});
							}
						});
					}
				},
				popupResize: function(pp, params){
					var popup = pp.parents('.simplemodal-container');
					popup.css('width','');
					popup.css('height','');
					if(params && params.height && params.width) {
						$.modal.update(params.height, params.width);
					}else{
						$.modal.update();
					}
				},
				/**
				 * Counts characters available in a given
				 * input / textarea. Just pass a 'selector'
				 * in the params and set the maxlength
				 * attribute of the input and it will add a span
				 * with class 'char-counter'.
				 * When the user can't add any more chars, the
				 * char-counter-max class is added
				 * Params:
				 *   selector (*): an input element or a container of input elements
				 *   customClass: an extra class to add to the span so you can style it at will
				 *   position: a jQuery-like position object where to place the span
				 *   		   see: http://api.jqueryui.com/position/
				 */
				charCounter: function(params){
					var elements = null;
					var singleElement = $(params.selector);
					if( singleElement.is("input[maxlength],textarea[maxlength]")){
						elements = singleElement;
					}else if( singleElement.children().length > 0 ) {
						elements = singleElement.find('input[maxlength], textarea[maxlength]');
					}else{
						//invalid selector
						return;
					}

					elements.each(function(){
						var supportOnInput = 'oninput' in document.createElement('input');
					    var $this = $(this);
					    var maxLength = parseInt($this.attr('maxlength'));
					    var text = $.i18n.prop('p.generic.charcounter.charsLeft', [maxLength]);
					    var el = $("<div class=\"char-counter font-c9\">"+
					    		text + "</div>");
					    if( params.customClass ){
					    	el.addClass(params.customClass);
					    }
					    el.insertAfter($this);
					    if( params.position ){
					    	el.position(params.position);
					    }else{
					    	el.addClass('char-counter-position');
					    }

					    //it may already have a value
					    var count = $this.val().length;
					    if( count > maxLength ){
					    	count = maxLength;
					    }
				        var text = $.i18n.prop('p.generic.charcounter.charsLeft', [maxLength-count]);
				        el.text(text);

					    $this.bind(supportOnInput ? 'input' : 'keyup', function() {
					        var count = $this.val().length;
					        var text = $.i18n.prop('p.generic.charcounter.charsLeft', [maxLength-count]);
					        el.text(text);
					        if( maxLength == count ){
					        	el.addClass('char-counter-max');
					        	el.removeClass('pulsate');
					        	el.addClass('pulsate');
					        }else{
					        	el.removeClass('char-counter-max');
					        	el.removeClass('pulsate');
					        }
					    });
					    $this.bind('keydown', function(){
					    	var count = $this.val().length;
					    	if( count == maxLength ){
					    		el.toggleClass('pulsate');
					    	}
					    });
					});

				},
				maskPhone: function(params){
					var singleElement = $(params.selector);
					var maskProperties = $.i18n.prop('c.mask.phone');
					
					jQuery(function($){
						$(singleElement).mask(maskProperties,{placeholder:""});	
						$(singleElement).on('click', function(){
							$(this).val($(this).val().trim());
						});
						
					});					
				},
				maskMobile: function(params){
					var singleElement = $(params.selector);
					var maskProperties = $.i18n.prop('c.mask.mobile');
					
					jQuery(function($){
						$(singleElement).mask(maskProperties,{placeholder:""});
						$(singleElement).on('click', function(){
							$(this).val($(this).val().trim());
						});
					});					
				},
				maskIdentityNumber: function(params){
					var singleElement = $(params.selector);
                    var maskProperties = $.i18n.prop('c.mask.DEFAULT.taxIdentity');
					var taxTypeVal = 'DEFAULT';
					
					if (params.typeSelector != null){
						var taxTypeText = $(params.typeSelector).text();
						taxTypeVal = $(params.typeSelector).val();
						maskProperties = $.i18n.prop('c.mask.' + taxTypeText + '.taxIdentity');	
					}					
	
					jQuery(function($){
						$(singleElement).mask(maskProperties,{placeholder: params.placeHolder});
					});					
				},
				onlyIntegers: function(selector){
                    $(selector).mask('9?9999999', {placeholder: ''});
				}
			}
		},
		Components : {
			Confirm : {
				/**
				 * A specific type of .popup() that shows a Confirm and Cancel buttons
				 * Callbacks are specified via data, with the ID that contains the
				 * title and body of a standard popup.
				 * Parameters:
				 * - data.id = the id of the popup
				 * - data.accept = the confirm callback (or leave empty)
				 * - data.cancel = the cancel callback (or leave empty)
				 * - data.acceptText = The accept button text
				 * - data.cancelText = The cancel button text
				 */
				open : function(data) {
					var popup = $('#'+data.id);
					var showCancel = true;
					if( typeof data.showCancel !== 'undefined' ){
						showCancel = data.showCancel;
					}
					var showAccept = true;
					if( typeof data.showAccept !== 'undefined' ){
						showAccept = data.showAccept;
					}
					var cancel = null;
					var accept = null;
					if( !popup.data('confirm-inited') ){
						var container = $('<div class="confirm text-center"></div>');
						var cancelText = data.cancelText || $.i18n.prop('p.generic.cancel');
						var acceptText = data.acceptText || $.i18n.prop('p.generic.accept');
						cancel = $('<div class="btn btn-medium btn-danger confirm-cancel">' + cancelText + '</div>');
						accept= $('<div class="btn btn-medium btn-success btn-green confirm-accept">' + acceptText + '</div>');
						container.append(cancel);
						container.append(accept);
						container.append('<div class="confirm-loader"></div>');
						popup.children('div:last').append(container);

						popup.data('confirm-inited',true);
					}else{
						accept = popup.find('.confirm-accept');
						cancel = popup.find('.confirm-cancel');

						accept.unbind('click');
						cancel.unbind('click');
					}
					if( !showCancel ){
						cancel.hide();
					}else{
						cancel.show();
						cancel.click(function(event){
							var popup = $(this).parents('.confirm');
							var prevent = false;
							if( data.cancel ){
								prevent = data.cancel(popup);
							}
							if( ! prevent ){
								$.modal.close();
							}
							
							if(data.onCancel){
								data.onCancel();
							}
						});
					}
					if( !showAccept ){
						accept.hide();
					}else{
						accept.click(function(event){
							if( $(this).hasClass('disabled') ){
								if( data.onAcceptDisabled ){
									data.onAcceptDisabled();
								}
								return;
							}
							var popup = $(this).parents('.confirm');
							var prevent = false;
							if(data.accept){
								prevent = data.accept(popup);
							}
							if( !prevent ){
								$.modal.close();
							}
							
							if(data.onConfirm){
								data.onConfirm();
							}
							
						});
					}
					Marb.Commons.Utils.popup(data);
				},

				close : function(){
					$.modal.close();
				},

				loading : function(confirmObj, setLoading){
					if( setLoading ){
						$(confirmObj).addClass('loading');
						$(confirmObj).find('.confirm-accept').addClass('disabled');
						$(confirmObj).find('.confirm-cancel').addClass('disabled');
					}else{
						$(confirmObj).removeClass('loading');
						$(confirmObj).find('.confirm-accept').removeClass('disabled');
						$(confirmObj).find('.confirm-cancel').removeClass('disabled');
					}
				},

				/**
				 * Opens a simple confirm popup. It only requires the title
				 * and body (text) of the confirm and callbacks for the yes and no
				 * options
				 * data.title = the title for the popup
				 * data.body = the body for the popup
				 * data.cancel = an optional callback when the cancel button is pressed
				 * data.accept = an optional callback when the accept button is pressed
				 * data.showCancel = if the popup has a cancel button or not.
				 */
				openSimple : function(data) {
					var title = data.title || '';
					var body = data.body || '';
					var bodyHtml = data.bodyHtml || '<span></span>';

					data.id = 'marb-confirm-simple';
					var popup = $('#marb-confirm-simple');
					if( popup.length != 0){
						popup.remove();
					}
					popup = $('<div id="marb-confirm-simple" class="collapse">' +
							  '    <div class="font-c1 title-m marb-confirm-simple-title"></div>' +
							  '    <div class="marb-confirm-simple-body">' + bodyHtml + '</div>' +
							  '</div>');
					$('body').append(popup);
					popup.find('.marb-confirm-simple-title').text(title);
					if( ! data.bodyHtml ){
						popup.find('.marb-confirm-simple-body span').text(body);
					}

					Marb.Components.Confirm.open(data);
				}
			},
			
			
			
			RegistrationPopUp : {
				show : function (params){
					var registrationPopUpId = "registration-popup";
					var springMessage = '<spring:message code="p.generic.email"/>';
					var onSuccess = params.onSuccess || function(){};
					var onError = params.onError || function(){};
					if( $('#'+registrationPopUpId).length == 0 ){
					var popup = $('\
							<div class="marb-confirm-simple"> \
								<div class="font-c1 title-m marb-confirm-simple-title">Registrate y accedé a los beneficios</div> \
								<div class="marb-confirm-simple-body"> \
									<div class='+registrationPopUpId+ ' > \
										<div class="collapse errors custom-error"></div> \
										<div class="entry"> \
											<input id="reg_username" name="username" type="text" value="" maxlength="128" placeholder='+$.i18n.prop('p.generic.email')+' /> \
						  				</div> \
						  				<div class="entry"> \
								   			<input id="reg_firstname" name="firstname" type="text" value="" maxlength="32" placeholder='+$.i18n.prop('p.generic.firstname')+' /> \
						  				</div> \
						  				<div class="entry"> \
											<input id="reg_lastname" name="lastname" type="text" value="" maxlength="32" placeholder='+$.i18n.prop('p.generic.lastname')+' /> \
						  				</div> \
						  				<div class="entry"> \
								   			<input id="reg_phone" name="phone" type="text" value="" maxlength="32" placeholder='+$.i18n.prop('p.generic.phone')+' /> \
						  				</div> \
						  				<div class="entry"> \
							            	<input id="reg_password" name="password" type="password" value="" maxlength="32" placeholder='+ $.i18n.prop('p.generic.password')+' /> \
						  				</div> \
						  				<div class="entry"> \
								   			<input id="reg_passwordConfirm" name="passwordConfirm" type="password" value="" maxlength="32" placeholder='+ $.i18n.prop('p.generic.password')+' /> \
						  				</div> \
							   			<div class="entry"> \
											<input class="btn btn-green reg_btnsign" name="insert" type="submit" value="Registrate"> \
						  				</div>\
									</div> \
								</div> \
							</div>\
						');
					
						popup.attr('id', registrationPopUpId);
						popup.hide();
						$('body').append(popup);
						
						popup.find('.reg_btnlogin').on('click', function(){
								$.modal.close();
								Marb.Components.LoginPopup.show(params);
						});
						
						
						popup.find('.reg_btnsign').on('click', function(){
							var newUser = {};
							newUser.username =$('#reg_username').val();
						    newUser.firstname =$('#reg_firstname').val();
						    newUser.lastname =$('#reg_lastname').val();
						    newUser.phone = $('#reg_phone').val();
						    newUser.password =$('#reg_password').val();
						    newUser.passwordConfirm =$('#reg_passwordConfirm').val();
						    newUser.marketingSource =  $('#reg_marketingSource').find(":selected").text()
						    newUser.token = $('#reg_value-for-token').val();
							
			        		var registered = M.Commons.Utils.registerUser(newUser);
			        		if( registered ){
			        			$('#'+registrationPopUpId+ ' .errors').hide();
			        			$.modal.close();
			        			onSuccess(params);
			        		}else{
			        			onError();
			        			$('#'+registrationPopUpId+' .errors').html($.i18n.prop('p.generic.invalidlogin')).show();
			        		}
						});
					}
					var registrationPopUp = Marb.Commons.Utils.popup({
						id: registrationPopUpId
					});
				}
			},
			
			LoginPopup : {
				show: function(params){
					var onSuccess = params.onSuccess || function(){};
					var onError = params.onError || function(){};
					if( $('#login-popup').length == 0 ){
						var popup =
							$('<div class="marb-confirm-simple"> \
								<div class="font-c1 title-m marb-confirm-simple-title">'+$.i18n.prop('p.generic.login')+'</div> \
								<div class="marb-confirm-simple-body"> \
									<div class="login-popup"> \
										<div class="collapse errors custom-error"></div> \
										<div class="entry"> \
											<label for="email">'+ $.i18n.prop('p.generic.email')+'</label> \
										   	<input type="text" name="j_username" value="" id="j_username" value="" /> \
										</div> \
										<div class="entry"> \
									        <label for="first">'+$.i18n.prop('p.generic.password')+'</label> \
										   	<input type="password" name="j_password" id="j_password"/><div class="clear"></div> \
										</div> \
								        <div class="centered text-s font-c1 uppercase" style="margin: 10px 0px;"> \
										 	<a href="/registration/forgot">'+$.i18n.prop('p.login.forgotpassword')+'</a> \
										 </div> \
										<div id="actions" class="centered uppercase"> \
										 	<span class="btn btn-green" name="insert">'+$.i18n.prop('p.generic.login')+'</span> \
										</div> \
									</div> \
								</div> \
							</div>');
						
						
						popup.attr('id', 'login-popup');
						popup.hide();
						
						$('body').append(popup);

						
						popup.find('.btn').on('click', function(){
							var username = $("#login-popup #j_username").val();
			        		var password = $("#login-popup #j_password").val();

			        		if( ! username || ! password || username.trim().length < 4 || password.trim().length < 4){
			        			$('#login-popup .errors').html($.i18n.prop('p.generic.invalidlogin')).show();
			        			return;
			        		}

			        		var logged = M.Commons.Utils.login(username, password);
			        		if( logged ){
			        			$('#login-popup .errors').hide();
			        			$.modal.close();
			        			onSuccess(params);
			        		}else{
			        			onError();
			        			$('#login-popup .errors').html($.i18n.prop('p.generic.invalidlogin')).show();
			        		}
						});
					}
					var loginPopup = Marb.Commons.Utils.popup({
						id: 'login-popup'
					});
				}
			},
			ChatPopup : (function() {
				var
					$e = null,
					_data,
					popUpTemplate = '<div id="messages-popup" class="collapse chatPopup"> \
									<div> \
										<div class="title-m font-c1">{{title}}</div> \
										<div class="providerName title-m bold font-c1">{{providerName}}</div> \
									</div> \
									<div class="content"> \
										<ul class="messages scrollable"> \
											{{#content}} \
												{{> messagePartial}} \
											{{/content}} \
										</ul> \
										<div class="spacer"></div> \
										<div class="inputArea"> \
											<a href="https://play.google.com/store/apps/details?id=com.marb.iguana" target="_blank" class="note font-c1">{{getAnroidApp}}</a> \
											<form action="" method="post"> \
												<div class="textBoxContainer"> \
													<textarea rows="3" tabindex="1"></textarea> \
												</div> \
												<div class="sendContainer">\
													<a href="#pivot" class="btn btn-medium btn-green send {{#disabled}}disabled{{/disabled}}" tabindex="2">{{buttonText}}</a> \
												</div> \
											</form> \
										</div> \
									</div> \
									</div>',
					popUpCustomerTemplate = '<div id="messages-popup" class="collapse chatPopup"> \
										<div> \
											<div class="title-m font-c1">{{title}}</div> \
											<div class="providerName title-m bold font-c1">{{providerName}}</div> \
										</div> \
										<div class="content"> \
											<ul class="messages scrollable"> \
												{{#content}} \
													{{> messagePartial}} \
												{{/content}} \
											</ul> \
											<div class="spacer"></div> \
											<div class="inputArea"> \
												<div class="tipchat note font-c1">{{createVisit}} <a title="{{createVisitTitle}}" onClick=\'$(".simplemodal-close").click(); $("div.customerAssignVisit[data-quoteid*={{quoteId}}]").click(); \'>{{createVisitHere}}</a></div> \
												<form action="" method="post"> \
													<div class="textBoxContainer"> \
														<textarea rows="3" tabindex="1"></textarea> \
													</div> \
													<div class="sendContainer">\
														<a href="#pivot" class="btn btn-medium btn-green send {{#disabled}}disabled{{/disabled}}" tabindex="2">{{buttonText}}</a> \
													</div> \
												</form> \
											</div> \
										</div> \
										</div>',
					pageTemplate = '<div id="messages-popup" class="chatPopup"> \
							<div class="content"> \
								<div class="inputArea"> \
									<form action="" method="post"> \
										<div class="textBoxContainer"> \
											<textarea rows="3" tabindex="1"></textarea> \
										</div> \
										<div class="sendContainer">\
											<a href="#pivot" class="btn btn-medium btn-green send {{#disabled}}disabled{{/disabled}}" tabindex="2">{{buttonText}}</a> \
										</div> \
									</form> \
								</div> \
								<div class="spacer"></div> \
								<ul class="messages scrollable"> \
									{{#content}} \
										{{> messagePartial}} \
									{{/content}} \
								</ul> \
							</div> \
						</div>',
					messageTemplate = '<li class="message {{type}}"> \
											{{#photo}}<img alt="" src="{{photo}}" />{{/photo}} \
											<div class="text">{{&text}} \
												{{#photo}}<img class="chatArrow" alt="" src="{{cdnUrl}}static/images/chat-left.png" />{{/photo}} \
												<div class="publishDate font-c2 text-xs">{{publishDate}}</div> \
											</div> \
											<div class="clear"></div> \
										</li>',
					compiledPopupTemplate = Mustache.compile(popUpTemplate),
					compiledPopupCustomerTemplate = Mustache.compile(popUpCustomerTemplate),
					compiledPageTemplate = Mustache.compile(pageTemplate),
					compiledMesssagePartial = Mustache.compilePartial('messagePartial', messageTemplate);
				
				var sendMessage = function(msg) {
					if(msg != '') {
						$.ajax(
							_data.postUrl,
							{
								type: 'POST',
								data: {
									c: msg
								}
							}
						).done(function(data){
								if(data.success) {
									pushMessage($('<div/>').text(msg).html().replace(/\n/g, "<br />"));
								}
								else {
									debug.error('Marb.Components.ChatPopup - Could not send message to the server');
								}
							}
						);
					}
				};

				var pushMessage = function(msg) {
					var htmlMessage = Mustache.render(messageTemplate, {
						cdnUrl: _data.cdnUrl,
						type: 'sender',
						photo: _data.senderId == _data.customerId? _data.customerPic : _data.companyPic,
						text: msg,
						publishDate: $.i18n.prop('p.generic.publishDate.recently')
					});
					if(_data.selector) {
						$e.find('.messages .mCSB_container').prepend(htmlMessage);
						$e.find('.scrollable').mCustomScrollbar('update');
						$e.find('.scrollable').mCustomScrollbar('scrollTo', 'top');

					} else {

						$e.find('.messages .mCSB_container').append(htmlMessage);
						$e.find('.scrollable').mCustomScrollbar('update');
						$e.find('.scrollable').mCustomScrollbar('scrollTo', 'bottom');
					}
					$e.find('textarea').val('');
				};

				var bindEvents = function() {
					$e
						.find('.inputArea .send:not(.disabled)').on('click', function() {
							var msg= $e.find('textarea').val().trim();
							sendMessage(msg);
						}).end()
						.find('.inputArea textarea').watermark($.i18n.prop('c.chatbox.watermark'), {
							className: 'empty',
							useNative: false
						});
				};

				var processData = function(data) {
					var formatedData = {};

					formatedData.cdnUrl = data.cdnUrl;
					formatedData.title = $.i18n.prop('c.chatbox.title');
					formatedData.providerName = data.receiverName;
					formatedData.postUrl = data.postUrl;
					formatedData.senderId = data.senderId;
					formatedData.customerId = data.customerId;
					formatedData.customerPic = data.customerPic;
					formatedData.companyPic = data.companyPic;
					formatedData.disabled = !data.acceptMessages;
					formatedData.buttonText = $.i18n.prop('c.chatbox.button');
					formatedData.getAnroidApp = $.i18n.prop('c.chatbox.getAndroidApp');
					formatedData.createVisit =  $.i18n.prop('c.chatbox.createVisit');
					formatedData.createVisitHere =  $.i18n.prop('c.chatbox.createVisitHere');
					formatedData.createVisitTitle =  $.i18n.prop('c.chatbox.createVisit.title');
					formatedData.content = [];
					formatedData.selector = data.selector;
					formatedData.quoteId = data.quoteId;
					for(var i=0, d=data.quoteMessages, len=d.length; i < len; i++) {
						var timeAgo = Marb.Commons.Utils.elapsedTimeText(d[i].createdOn);

						if(data.selector) {
							formatedData.content.unshift({
								type: d[i].customerId == 0? 'fromSystem' : (d[i].customerId == formatedData.senderId? 'sender' : 'receiver'),
								text: d[i].body.replace(/\n/g, "<br />"),
								photo: d[i].customerId == 0? null : d[i].customerId == formatedData.customerId? formatedData.customerPic : formatedData.companyPic,
								publishDate: timeAgo
							});
						} else {
							formatedData.content.push({
								type: d[i].customerId == 0? 'fromSystem' : (d[i].customerId == formatedData.senderId? 'sender' : 'receiver'),
								text: d[i].body.replace(/\n/g, "<br />"),
								photo: d[i].customerId == 0? null : d[i].customerId == formatedData.customerId? formatedData.customerPic : formatedData.companyPic,
								publishDate: timeAgo
							});
						}
					}

					_data = formatedData;
					return formatedData;
				};

				var show = function(data) {
					if(typeof data == "object" && data != null ) {
						if(!data.selector) {
							$('.chatPopup').remove();
						}
						data = processData(data);
						
						var result;
						if(data.selector) {
							result = compiledPageTemplate(data);
							$e = $(result).appendTo(data.selector);
						} else {
							result = compiledPopupTemplate(data);
							$e = $(result).appendTo('body');
						}
						//manage scrolls before showing popup
						//and to set the right sizing if there is a scrollbar
						$e.find('.scrollable').mCustomScrollbar({
							theme: 'dark-thick',
							scrollInertia: 0
						});
						$e.find('.scrollable').mCustomScrollbar('scrollTo', 'bottom');
						
						if( ! data.selector ){
							//re process scrolling so it actually shows up.
							Marb.Commons.Utils.popup('messages-popup', {});
							//manage scrolls before showing popup
							
							$e.find('.scrollable').mCustomScrollbar('update');
							$e.find('.scrollable').mCustomScrollbar('scrollTo', 'bottom');
						}

						bindEvents();
					}
					else {
						debug.error('Marb.Components.ChatPopup - To show the chat popup you must provide its data in an object');
					}
				};

				return {show: show};
			})()
		}
	});
}
catch (e) {
	debug.error("Marb namespace not present", e);
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) != -1) return c.substring(name.length,c.length);
    }
    return "";
} 

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}

function deleteCookie( name ) {
	  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}


/**
 * QualityChecker is an object that gives feedback rate for a collection of elements.
 * (i.e.: Quote completeness:  price, comment and company avg rate)
 * 
 * @param: options: configuration object 
 * 					{
 * 						defaultQualityValue: minimum value before applying any quality check;
 * 						nonCountableWords[]: array with the words that don´t count for the textCheck function.
 * 						elements[]: array of elements that should be checked for quality.
 * 									{
 * 										selector:	jQuery selector
 * 										checker: 	type of check. There are 3 kind
 * 													-booleancheck: should be used for radiobutton and checkbox
 * 													-textcheck: should be used for inputtext and textarea
 * 													-directcheck: unilateral assign of percentage to the overall quality value 
 * 										percentage:	maximum amount that this particular check represents to the overall quality value 
 * 										helpTip: 	help text that will be displayed if the percentage is not reached
 * 												{
 * 													text: tip text
 * 													callback: function to customize the displa of the tip text
 * 									}
 * 						isDebug: boolean that enables logging for debugging purposes
 * 					}
 * 
 */
function QualityChecker(options) {
	var self = this;
	this.isDebug = options.isDebug ? options.isDebug : false;
	this.defaultQualityValue = options.defaultQualityValue ? options.defaultQualityValue
			: 0;
	this.qualityValue = this.defaultQualityValue;
	this.nonCountableWords = options.nonCountableWords ? options.nonCountableWords
			: [];
	this.elements = options.elements ? options.elements : [];
	this.helpTip = '';
	this.booleanCheck = function(selector, percentage) {
		if (!$(selector).is(":checked")){
			return percentage;
		}
		return 0;
	}
	/**
	 * It strips the original text from all kind of special characters, and then excludes
	 * the nonCountableWords also.
	 * This particular check has 3 ranges:
	 *   0-60  words: 1/3 of the percentage assigned
	 *  61-120 words: 2/3 of the percentage assigned
	 * 120+ words	: percentage assigned
	 */
	this.textCheck = function(selector, percentage) {
		var percentageUnit = Math.round(percentage / 3);

		var data = $(selector).val();

		if (data == '') {
			return 0;
		}

		if (this.isDebug) {
			console.log('Raw text: ' + data);
		}

		var cleanedText = data.replace(/\s+|\W+|\.+/g, ' ') //Limpio caracteres especiales y multiples espacios
		.replace(/\,+|\:+/g, '') //Limpio , y :
		.trim(); //Limpio los espacios a los costados

		if (this.isDebug) {
			console.log('Clean text: ' + cleanedText);
		}

		var words = cleanedText.split(' ');
		var filteredWords = new Array();

		var numberOfWords = words.length;

		if (this.isDebug) {
			console.log('words size: ' + numberOfWords);
		}

		words.forEach(function(entry) {
			if ($.inArray(entry.toLowerCase(), self.nonCountableWords) == -1) {
				filteredWords.push(entry);
			}
			;
		});

		numberOfWords = filteredWords.length;

		if (this.isDebug) {
			console.log('filteredWords size: ' + numberOfWords);
		}

		if (numberOfWords > 100) {
			return percentage;
		}else{
			return Math.round((numberOfWords * percentage)/100);
		}
	}

	/**
	 * This method should be called to make the quality check over the elements.
	 * Calculates the QualityValue and the helpTip to display(if needed).
	 */
	this.check = function() {
		this.qualityValue = this.defaultQualityValue;
		this.helpTip = '';
		self.elements.forEach(function(entry) {
//			entry.helpTip.callback('');
			var calculatedValue;
			if (entry.checker.toLowerCase() == 'booleancheck') {
				calculatedValue = self.booleanCheck(entry.selector,
						entry.percentage);
			} else if (entry.checker.toLowerCase() == 'textcheck') {
				calculatedValue = self.textCheck(entry.selector,
						entry.percentage);
			} else if (entry.checker.toLowerCase() == 'directcheck') {
				calculatedValue = entry.percentage;
//				if (self.helpTip == '' && entry.percentage == 0) {
//					self.helpTip = entry.helpTip.text;
//					entry.helpTip.callback(entry.helpTip.text);
//				}
			}

			self.qualityValue += calculatedValue;

			if (entry.percentage == 0 || entry.percentage != calculatedValue) {
				self.helpTip = entry.helpTip.text;
				entry.helpTip.callback(entry.helpTip.selector,entry.helpTip.text);
			}else{
				$(entry.helpTip.selector).fadeOut(1000, function(){$(this).hide()});
			}
		})
		if (this.isDebug) {
			console.log('Quality Check Result: ' + self.qualityValue);
		}
	}

	QualityChecker.prototype.getQualityValue = function() {
		return this.qualityValue;
	}

	QualityChecker.prototype.getHelpTip = function() {
		return this.helpTip;
	}

	QualityChecker.prototype.getNonCountableWords = function() {
		return this.nonCountableWords;
	}

	QualityChecker.prototype.getElements = function() {
		return this.elements;
	}
}
